import { useMemo } from 'react'
import { getDisableGroupByOptions } from '../../../utils/aggregationUtils'
import { makePairNameValueObject } from '../../../utils/tools'

const selectRole = [
    {value: 'equal', name:'Equal'},
    {value: 'between' , name: 'Between'},
    {value: 'gt', name:'Greater Than'},
    {value: 'lt', name:'Less Than'},
    {value: 'gte' , name: 'Greater Than or Equal To'},
    {value: 'lte' , name: 'Less Than or Equal To'},    
]

const group = [
    {value: 'daily' , name: 'Daily'},
    {value: 'weekly' , name: 'Weekly'},
    {value: 'monthly', name: 'Monthly'},
    {value: 'quarterly', name:'Quarterly'},
]


const market_Cap = ['11M - 2B','2B - 10B','10B - 100B','100B+']
const exchange = ['NYSE','NASDAQ']
const FinancialKPIsOptions = [{label:'Price',id:0}]

const useScreenerFilters = (frequency) => {

    const initAlternativeField = {datasetValue:'', columnValue:'', forTimeperiod: frequency, change: {change: 1}, rule: selectRole[0].value,althub_dataset_id:null,althub_client_id:null}
    const initFinancialKPIField = {KPI:'', forTimeperiod: frequency, change: {change: 1}, rule: selectRole[0].value}

    const defaultFrequency = useMemo(() => {
        const inGroup = group.some(({value}) => value === frequency)
        return inGroup ? frequency : group[0].value
    },[frequency])

    const selectTimePeriod = useMemo(()=> getDisableGroupByOptions(defaultFrequency, group),[defaultFrequency])

    const marketCapOptions = useMemo(() => makePairNameValueObject(market_Cap, market_Cap), [])
    const exchangeOptions = useMemo(() => makePairNameValueObject(exchange, exchange), [])
    // const FinancialKPIsOptions = useMemo(()=> makePairNameValueObject(FinancialKPIs,FinancialKPIs))

    return {
        selectRole,
        selectTimePeriod,
        initAlternativeField,
        marketCapOptions,
        exchangeOptions,
        defaultFrequency,
        FinancialKPIsOptions,
        initFinancialKPIField
    }
}

export default useScreenerFilters